module.exports = __webpack_public_path__ + "static/media/om_hairstyle_slickedback_front.511917f2.png";